import { render, staticRenderFns } from "./sendRecRequest.vue?vue&type=template&id=25228520&scoped=true&"
import script from "./sendRecRequest.vue?vue&type=script&lang=js&"
export * from "./sendRecRequest.vue?vue&type=script&lang=js&"
import style0 from "./sendRecRequest.vue?vue&type=style&index=0&id=25228520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25228520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25228520')) {
      api.createRecord('25228520', component.options)
    } else {
      api.reload('25228520', component.options)
    }
    module.hot.accept("./sendRecRequest.vue?vue&type=template&id=25228520&scoped=true&", function () {
      api.rerender('25228520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/components/sendRecRequest.vue"
export default component.exports